export default {
  INIT: 'AUTH/INIT',
  SIGNIN: 'AUTH/SIGNIN',
  SIGNOUT: 'AUTH/SIGNOUT',
  SIGNIN_SUCCESS: 'AUTH/SIGNIN_SUCCESS',
  SIGNIN_ERROR: 'AUTH/SIGNIN_ERROR',
  SIGNOUT_SUCCESS: 'AUTH/SIGNOUT_SUCCESS',
  SIGNOUT_ERROR: 'AUTH/SIGNOUT_ERROR',
}
